export const ultimaSettimana="ultimaSettimana"
export const ultimoMese="ultimoMese"
export const meseCorrente="meseCorrente"
